module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "track-content-preview"
  }, [(!_vm.content) ? _c('span', [_vm._v("—")]) : [_c('div', {
    ref: "clamp",
    staticClass: "track-md track-content-clamp",
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  }), _vm._v(" "), (_vm.overflow) ? _c('a', {
    staticClass: "track-content-view",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('view')
      }
    }
  }, [_vm._v("查看")]) : _vm._e()], _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08b1d9b9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/TrackContentPreview.vue
// module id = 1629
// module chunks = 8